import { render, staticRenderFns } from "./SmallBoxes.vue?vue&type=template&id=2af0f42c"
import script from "./SmallBoxes.vue?vue&type=script&lang=js"
export * from "./SmallBoxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports